@if (type() !== 'hidden') {
<div
  class="plan-banner"
  id="plan-banner"
  [ngClass]="type()"
  [class.collapsed]="collapsed"
  [matTooltipDisabled]="!collapsed"
  matTooltipClass="menu-tooltip"
  [matTooltip]="type() === 'free-trial' ? daysLeft() + ' days left' : cta()"
  matTooltipPosition="after"
>
  @if (!collapsed) { @if (badge()) {
  <div
    class="badge"
    [class.action-needed]="
      type() === 'billing-issue' || type() === 'expires-soon'
    "
  >
    {{ badge() }}
  </div>
  }
  <div class="title">{{ title() }}</div>
  <div class="description">
    <span>{{ description() }}</span>
  </div>
  @if (type() === 'free-trial') {
  <ng-container *ngTemplateOutlet="freeTrial"></ng-container>
  }
  <button
    class="tw-mt-6 tw-w-full tw-font-medium"
    mat-stroked-button
    (click)="actionClick()"
  >
    <mat-icon class="thin" svgIcon="upgrade-default" />{{ cta() }}
  </button>
  } @else { @if (type() === 'free-trial') {
  <span (click)="actionClick()">{{ daysLeft() }}</span>
  } @else {
  <button mat-icon-button (click)="actionClick()">
    <mat-icon class="thin" svgIcon="upgrade-default" />
  </button>
  } }
</div>
}

<ng-template #freeTrial>
  <mat-progress-bar
    class="tw-my-6"
    mode="determinate"
    [value]="progressValue()"
  ></mat-progress-bar>
  <div class="tw-flex tw-items-center tw-justify-end">
    <span id="trial-plan-banner" class="days-left tw-text-gray-700"
      >{{ daysLeft() }} days left</span
    >
  </div>
</ng-template>
